import React from 'react';

import moment from 'moment'

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {DateInput, NumberInput, required, Title} from 'react-admin';
import {downloadFile, ReportForm} from '../../components';
import env from '../../env';

class ReceiptUsageReport extends React.Component {
  state = {
    fromDate: moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    fromBillNum: "",
    toBillNum: "",
    isLoading: false
  };

  getReportUrl = () => {
    return `${env.reportURL}/reports/detailReceiptUsage?pFromDate=` + this.state.fromDate +
        `&pToDate=` + this.state.toDate + `&fromBillNum=${this.state.fromBillNum}&toBillNum=${this.state.toBillNum}`
  }

  excelReport = () => {
    this.setState({isLoading: true})
    downloadFile(this.getReportUrl(), 'bao_cao_chi_tiet_hoa_don.xlsx').finally(() => this.setState({isLoading: false}))
  }

  validate = (values) => {
    const errors = {};

    // Validate
    if (values.fromDate && values.toDate && (values.fromDate > values.toDate) ){
      errors.toDate = 'To date must be greater than From date'
    }

    this.setState({
      fromDate: values.fromDate,
      toDate: values.toDate,
      fromBillNum: values.fromBillNum || "",
      toBillNum: values.toBillNum || ""
    })


    return errors;
  }

  render() {
    return (
      <Card>
        <Title title="resources.chiTietHoaDonReport.name" />
        <CardContent>
          <ReportForm params={this.state}
            validate={this.validate}
            excelReport={this.excelReport}
                      isLoading={this.state.isLoading}
          >
            <Grid container spacing={8}>
              <Grid item xs={12} sm={6} >
                <DateInput label="resources.common.fromDate" source="fromDate" validate={required()} {...this.props} />
              </Grid>
              <Grid item xs={12} sm={6} >
                <DateInput label="resources.common.toDate" source="toDate" validate={required()} {...this.props} />
              </Grid>
            </Grid>
            <Grid container spacing={8}>
              <Grid item xs={12} sm={6}>
                <NumberInput label={"resources.chiTietHoaDonReport.fromBillNum"} source="fromBillNum"/>
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput label={"resources.chiTietHoaDonReport.toBillNum"} source="toBillNum"/>
              </Grid>
            </Grid>
          </ReportForm>

        </CardContent>
      </Card>
    )
  }
}

export default ReceiptUsageReport;

